import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const ShopView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [shop, setShop] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Http.get(`/accounts/shops/${id}`)
      .then((res) => {
        setShop(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Shop Details</h5>
          <div className="am-right">
            <button
              className="btn btn-secondary"
              onClick={() => navigate("/shops")}
            >
              <i className="fa fa-arrow-left mg-r-10"></i>
              Back to List
            </button>
          </div>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Shop Information</h6>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Shop Name</th>
                      <td>{shop.name}</td>
                    </tr>
                    <tr>
                      <th>Balance</th>
                      <td>${parseFloat(shop.balance || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <th>Address</th>
                      <td>{shop.address || 'N/A'}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        <span className={`badge ${shop.status ? 'badge-success' : 'badge-danger'}`}>
                          {shop.status ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>{shop.created_at ? new Date(shop.created_at).toLocaleDateString() : 'N/A'}</td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>{shop.updated_at ? new Date(shop.updated_at).toLocaleDateString() : 'N/A'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            
            {!loading && (
              <div className="row mg-t-30">
                <div className="col-lg">
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate(`/edit-shop/${id}`)}
                  >
                    <i className="fa fa-edit mg-r-10"></i>
                    Edit Shop
                  </button>
                  <button
                    className="btn btn-secondary mg-l-10"
                    onClick={() => navigate("/shops")}
                  >
                    <i className="fa fa-arrow-left mg-r-10"></i>
                    Back to List
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopView;